import { useEffect } from "react";

const MetaTags = ({ product }) => {
  useEffect(() => {
    if (!product) return;

    // Update document title
    document.title = `${product.Name} - ${product.FrameColor} | Aram EyeCare`;

    // Function to update or create meta tag
    const updateMetaTag = (property, content, isName = false) => {
      const attribute = isName ? "name" : "property";
      let meta = document.querySelector(`meta[${attribute}="${property}"]`);

      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute(attribute, property);
        document.head.appendChild(meta);
      }

      meta.setAttribute("content", content);
    };

    // Get current URL
    const currentUrl = window.location.href;

    // Product details for sharing
    const productTitle = `${product.Name} - ${product.FrameColor}`;
    const productDescription = `${product.FrameColor} ${
      product.Material || ""
    } eyewear - Only ₹${product.Cost}. Available at Aram EyeCare.`.trim();
    const productImage =
      product.ImageUrl1 || `${window.location.origin}/logo512.png`;

    // Update Open Graph meta tags
    updateMetaTag("og:title", productTitle);
    updateMetaTag("og:description", productDescription);
    updateMetaTag("og:image", productImage);
    updateMetaTag("og:url", currentUrl);
    updateMetaTag("og:type", "product");
    updateMetaTag("og:site_name", "Aram EyeCare");

    // Update Twitter Card meta tags
    updateMetaTag("twitter:card", "summary_large_image", true);
    updateMetaTag("twitter:title", productTitle, true);
    updateMetaTag("twitter:description", productDescription, true);
    updateMetaTag("twitter:image", productImage, true);

    // Update regular meta description
    updateMetaTag("description", productDescription, true);

    // Add product-specific meta tags
    updateMetaTag("product:price:amount", product.Cost);
    updateMetaTag("product:price:currency", "INR");
    updateMetaTag("product:availability", "in stock");
    updateMetaTag("product:condition", "new");
    updateMetaTag("product:brand", "Aram EyeCare");

    // Cleanup function to reset meta tags when component unmounts
    return () => {
      // Reset to default values
      document.title = "Aram EyeCare - Premium Eyewear Collection";
      updateMetaTag("og:title", "Aram EyeCare - Premium Eyewear Collection");
      updateMetaTag(
        "og:description",
        "Discover premium eyewear collection at Aram EyeCare. Quality frames, sunglasses, and optical solutions."
      );
      updateMetaTag("og:image", `${window.location.origin}/logo512.png`);
      updateMetaTag("og:url", window.location.origin);
      updateMetaTag("og:type", "website");
    };
  }, [product]);

  return null; // This component doesn't render anything
};

export default MetaTags;
